import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
   enableProdMode();
}

platformBrowserDynamic()
   .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
   .then((ref) => {
      // Ensure Angular destroys itself on hot reloads.
      if (window['ngRef']) {
         window['ngRef'].destroy();
      }
      window['ngRef'] = ref;
      // Otherwise, log the boot error
   })
   .catch((err) => console.error(err));
